import { MeetingItem } from "./meetingItem";

export enum MeetingStatus {
    Draft = "draft",
    Planned = "planned",
    InReview = "inreview",
    Reviewed = "reviewed",
    Published = "published"
}

export interface Meeting {
    id?: string
    name: string
    status?: MeetingStatus
    date?: Date
    startTime?: string
    endTime?: string
    creator?: string
    index?: number
    identifier?: string
    reviewer?: string
    participants?: string[]
    viewers?: string[]
    items?: MeetingItem[]
    attachments?: number
    createdDate?: Date
    updatedDate?: Date
    project?: string
    defaultTags?: string[]
    inReviewOn?: Date
    publishedOn?: Date
    archived?: boolean
    eventId?: string
    calendarOrganizerEmail?: string
    teamsOnlineMeetingId?: string
    teamsJoinWebUrl?: string
    summary?: string
    bulletPoints?: string[]
    kernThema?: string
    zielDerBesprechung?: string
    wesentlichesErgebnis?: string
    aiSummaryStatus?: "pending" | "processing" | "completed" | "failed"
    aiProcessedDate?: Date
    aiProcessingError?: string
    aiSummaryVersion?: number
    aiSummaryVersionCreatedAt?: string
}
